import { NotificationConfiguration } from '../notification.templates';

export const PUBLISH_MEETING_FINAL_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> published the final version of the meeting minutes.`,
  email: {
    ctaKey: 'go_to_meeting',
  },
};
